import { createFormHook, createFormHookContexts } from "@tanstack/react-form";

export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();

export const { useAppForm, withForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {},
  formComponents: {},
});

// export function usePycomFormContext() {
//   return useFormContextBase() as unknown as {
//     Field: React.ComponentType<{
//       name: string;
//       validators?: any;
//       children: (field: any) => React.ReactNode;
//     }>;
//   };
// }
